export abstract class DateService {

  public static toTimeFromDate(date: Date): string {

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const newMinutes = minutes < 10 ? '0' + minutes : minutes;
    const time = hours + ':' + newMinutes + ' ' + ampm;

    return time;
  }
}
